import { render, staticRenderFns } from "./CompletedCampaignCard.vue?vue&type=template&id=5cc9b6fb&scoped=true&"
import script from "./CompletedCampaignCard.vue?vue&type=script&lang=ts&"
export * from "./CompletedCampaignCard.vue?vue&type=script&lang=ts&"
import style0 from "./CompletedCampaignCard.vue?vue&type=style&index=0&id=5cc9b6fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc9b6fb",
  null
  
)

export default component.exports